import { render } from "./BasketModal.vue?vue&type=template&id=53bc8780&scoped=true"
import script from "./BasketModal.vue?vue&type=script&lang=js"
export * from "./BasketModal.vue?vue&type=script&lang=js"

import "./BasketModal.vue?vue&type=style&index=0&id=53bc8780&lang=scss&scoped=true"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53bc8780"]])

export default __exports__